// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportStory_wrapper__ZSRxZ","item":"ReportStory_item__YjDyb","input":"ReportStory_input__Bbqdu","checkbox":"ReportStory_checkbox__jKz-t"};